import { useQuery } from '@tanstack/react-query';
import { getTwoFactorAppKey } from '../requests';

const useTwoFactorAppKey = ({ enabled }: { enabled: boolean }) => {
  const { data, isFetching, isError, refetch, isSuccess } = useQuery({
    queryKey: ['two-factor-app-key'],
    queryFn: getTwoFactorAppKey,
    enabled,
  });

  return {
    twoFactorAppKey: data,
    isTwoFactorAppKeyFetching: isFetching,
    isTwoFactorAppKeyError: isError,
    refetchTwoFactorAppKey: refetch,
    isTwoFactorAppKeySuccess: isSuccess,
  };
};

export { useTwoFactorAppKey };
